module.exports = __webpack_public_path__ + "img/41_45.ca538358.png";